import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Building } from 'lucide-react';
import { DialplanNodeData } from '@/types/dialplan-nodes';

export const TenantContextNode: React.FC<NodeProps<DialplanNodeData>> = ({ data, selected }) => {
  // Il wire può veicolare varianti snake_case non dichiarate in DialplanNodeData
  // (context_name / tenant_slug): cast-once verso una shape strutturale esplicita.
  const wireData = data as DialplanNodeData & { context_name?: string; tenant_slug?: string };
  return (
    <div
      className={`
        px-4 py-3 rounded-lg border-2 bg-gradient-to-br from-yellow-50 to-yellow-100
        ${selected ? 'border-yellow-500 shadow-lg' : 'border-yellow-300 shadow'}
        min-w-[180px]
      `}
    >
      <Handle
        type="target"
        position={Position.Left}
        className="!bg-yellow-500 !w-3 !h-3"
      />

      <div className="flex items-center gap-2 mb-2">
        <Building className="h-5 w-5 text-yellow-600" />
        <div className="flex-1">
          <div className="font-semibold text-yellow-900">{data.label}</div>
          {data.description && (
            <div className="text-xs text-yellow-700">{data.description}</div>
          )}
        </div>
        {!data.enabled && (
          <div className="px-2 py-0.5 bg-gray-200 text-gray-600 text-xs rounded">
            Disabled
          </div>
        )}
      </div>

      {(wireData.contextName || wireData.context_name) && (
        <div className="text-xs text-yellow-700 mt-1">
          Context: {wireData.contextName || wireData.context_name}
        </div>
      )}

      {wireData.tenant_slug && (
        <div className="text-xs text-yellow-700 mt-1">
          Tenant: {wireData.tenant_slug}
        </div>
      )}

      {data.priority !== undefined && (
        <div className="text-xs text-yellow-700 mt-1">
          Priority: {data.priority}
        </div>
      )}
    </div>
  );
};

